import { SidebarUserMenu } from './SidebarUserMenu';
import { cn } from '@/core/lib/utils';
import { useSidebar } from '@/core/hooks/useSidebar';
import { useUIStore } from '@/core/stores/ui.store';
import { HomePanel } from './panels/home/HomePanel';
import { AnalyticsPanel } from './panels/analytics/AnalyticsPanel';
import { NotesPanel } from './panels/notes/NotesPanel';
import { PanelContent } from './SidebarPanelContent';
import { SettingsNavPanel } from '@/features/settings/components/SettingsNavPanel';

export function SidebarPanel() {
  const { isOpen } = useSidebar();
  const activePanelId = useUIStore((s) => s.activePanelId);

  const isHome = activePanelId === 'home';
  const isSettings = activePanelId === 'settings';
  const isAnalytics = activePanelId === 'analytics';
  const isNotes = activePanelId === 'notes';

  const renderPanel = () => {
    if (isHome) return <HomePanel />;
    if (isSettings) return <SettingsNavPanel />;
    if (isAnalytics) return <AnalyticsPanel />;
    if (isNotes) return <NotesPanel />;
    return <PanelContent />;
  };

  return (
    <div
      className={cn(
        'overflow-hidden transition-all duration-300 ease-in-out shrink-0',
        isOpen ? 'w-60' : 'w-0',
      )}
    >
      <div className="w-60 h-full flex flex-col bg-background border-r border-border overflow-hidden">
        <div className="flex-1 min-h-0 flex flex-col overflow-y-auto">{renderPanel()}</div>

        <SidebarUserMenu />
      </div>
    </div>
  );
}
